import { getUrlParam } from '@tencent/vft-common/util';
import { getVuid } from '@tencent/vft-common/login';
export default {
  token: getUrlParam('token'),
  vuid: +getVuid(),
  ptag: getUrlParam('ptag'),
  fromtv: getUrlParam('fromtv'),
  mvuid: getUrlParam('mvuid'),
  fullscreen: getUrlParam('fullscreen')
};
export var PACKAHE_PTAG = {
  APP: {
    vip: {
      连续包月: 'SPsportCNY1',
      季卡: 'SPsportCNY2'
    },
    svip: {
      连续包月: 'SPsportCNY3',
      季卡: 'SPsportCNY4'
    }
  },
  QQSports: {
    vip: {
      连续包月: 'TYsportCNY1',
      季卡: 'TYsportCNY2'
    },
    svip: {
      连续包月: 'TYsportCNY3',
      季卡: 'TYsportCNY4'
    }
  },
  QQNews: {
    vip: {
      连续包月: 'XWsportCNY1',
      季卡: 'XWsportCNY2'
    },
    svip: {
      连续包月: 'XWsportCNY3',
      季卡: 'XWsportCNY4'
    }
  },
  TV: {
    vip: {
      连续包月: 'OTsportCNY1',
      季卡: 'OTsportCNY2'
    },
    svip: {
      连续包月: 'OTsportCNY3',
      季卡: 'OTsportCNY4'
    }
  }
};